import * as React from 'react';
import DialogBase from '../../../Shared/DialogBase';
import { SaveImageMapTodoDetailRequest, TodoDTO, TodoListDTO, TodoMainVovClient } from '../../../../ApiOld/Api/ApiServerVov';
import { Autocomplete, Box, Button, Grid, IconButton, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { TodoStates } from '../../ToDoOld/TodoStates';
import AdminUserSelect from '../../../Shared/AdminUserSelect';
import ColorPickerDialog from '../../../Shared/ColorPickerDialog';
import { useApi } from '../../../../ApiOld/Api/useApi';
import { LocationOn, SaveOutlined } from '@mui/icons-material';

export interface IImageMapTaskDetailDialogProps {
    open: boolean;
    onClose: (task: TodoListDTO | undefined) => void;
    taskMain: TodoListDTO;
    mapId: number;
    canGoToTask: boolean;
}

export default function ImageMapTaskDetailDialog(props: IImageMapTaskDetailDialogProps) {
    const { open, onClose, taskMain, canGoToTask } = props;
    const [task, setTask] = React.useState<TodoListDTO>(taskMain);
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const params = useParams();
    const optionsStates = TodoStates(t);
    const [changed, setChanged] = React.useState(false);
    const [pickingColor, setPickingColor] = React.useState(false);
    const { authorizedApi } = useApi(TodoMainVovClient);
    const save = React.useCallback(async () => {
        const id = await authorizedApi.saveImageMapTodoDetail(new SaveImageMapTodoDetailRequest({
            id: task.id,
            name: task.name,
            responsibleId: task.responsiblePersonId,
            status: task.state,
            mapTagColor: task.mapTagColor,
            mapId: props.mapId,
            mapLeft: task.mapLeft,
            mapTop: task.mapTop,
            description: task.description
        }));
        setChanged(false);

        onClose(new TodoListDTO({ ...task, id: id.id }));
    }, [authorizedApi, task, onClose, props.mapId]);
    return (
        <DialogBase
            dialogActions={
                <Box>
                    <Button sx={{ mr: 2, minWidth: 120 }} variant='outlined' onClick={() => onClose(undefined)}>{t('close')}</Button>
                    <Button variant='contained' startIcon={<SaveOutlined />} onClick={save} disabled={!changed || !((task.name?.length ?? 0) > 0) || !task.responsiblePersonId || (task.state === undefined || task.state === null)} >{t('save')}</Button>
                </Box>
            }
            open={open} onClose={() => onClose(undefined)} title={t('todo.taskOnMap')}>
            <Grid mt={1} container spacing={2} p={1}>
                <Grid item xs={8}>



                    <AdminUserSelect fullWidth selectedUserId={task.responsiblePersonId} onChange={(res) => {
                        setTask(new TodoListDTO({ ...task, responsiblePersonId: res ? res.id : undefined }));
                        setChanged(true);
                    }} label={t('todo.responsibleUser')} />

                </Grid>
                <Grid item xs={4}>
                    {task.id && task.id > 0 && canGoToTask && <Button onClick={() => navigate('/' + params['lang'] + '/' + params['domain'] + '/userlayout/todos/todomapdetail/' + task.id)}>{t('todo.goToTask')}</Button>}
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={task.name}
                        fullWidth
                        size='small'
                        onChange={(e) => { setTask(new TodoListDTO({ ...task, name: e.currentTarget.value })); setChanged(true); }}
                        label={t('name')}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={task.description}
                        multiline
                        fullWidth
                        minRows={3}
                        maxRows={10}
                        size='small'
                        onChange={(e) => { setTask(new TodoListDTO({ ...task, description: e.currentTarget.value })); setChanged(true); }}
                        label={t('Description')}
                        inputProps={{
                            sx: {
                                minHeight: "100px",
                                overflow: "auto",
                            },
                        }}
                    />
                </Grid>


                <Grid item xs={12}>
                    <Autocomplete
                        disablePortal
                        fullWidth
                        disableClearable
                        id="combo-box-demo"
                        size="small"
                        onChange={(e, v) => {
                            setTask(new TodoListDTO({ ...task, state: (v !== undefined && v !== null ? v!.id : undefined) }));
                            setChanged(true);
                            // console.log("contextId: " + v !== undefined && v !== null ? v!.id : "NIC");
                        }}
                        value={optionsStates.find((opt) => opt.id === task.state)}
                        options={optionsStates}

                        renderInput={(params) => <TextField
                            error={false}
                            helperText={''}
                            {...params}
                            label={t('state')} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ColorPickerDialog open={pickingColor} onClose={() => { setPickingColor(false) }}
                        onChangeCompleted={(color) => { setTask(new TodoListDTO({ ...task, mapTagColor: color })); setChanged(true); }} color={task.mapTagColor ?? '#000000'} />


                    <TextField
                        size='small'
                        fullWidth
                        onClick={() => { setPickingColor(true) }}
                        label={t('singleTodo.taskColor')}
                        value={task.mapTagColor ?? '#000000'} // Assuming task.color holds the hex value
                        onChange={(e) => {
                            const color = e.target.value;
                            // Basic hex validation
                            if (/^#[0-9A-Fa-f]{6}$/.test(color)) {
                                setTask(new TodoListDTO({ ...task, mapTagColor: color }));
                            }
                        }}
                        placeholder='#000000'
                        InputProps={{
                            endAdornment: (
                                <IconButton>
                                    <LocationOn onClick={() => { setPickingColor(true) }} fontSize={'small'} htmlColor={task.mapTagColor ?? '#000000'} />
                                </IconButton>
                            ),
                        }}
                    />
                </Grid>
            </Grid>
        </DialogBase>
    );
}
